import React, { useContext } from "react";
import { Button, Modal } from "react-bootstrap";
import { useTranslation } from "react-i18next";
import { Navigate } from "react-router";
import { InventoryConsumption } from "../../../Context/InventoryConsumption";

export const BuyAddonPlan = () => {
  const { t: locale } = useTranslation();
  const {
    showBuyAddonPlan,
    inventoryType,
    setShowBuyAddonPlan,
    buttonSelection,
    setButtonSelection,
    redirectTo,
    setRedirectTo,
  } = useContext(InventoryConsumption);
  const buyAddonPlan = async (value) => {
    await setButtonSelection(value);
    await setRedirectTo(true);
  };

  const hideModal = () => {
    setShowBuyAddonPlan(false);
  };

  const formattedInventoryType =
    inventoryType === "document"
      ? "space"
      : inventoryType === "booking_form"
        ? "Service Request Form"
        : inventoryType === "job_templates_count"
          ? "job templates count"
        : inventoryType
          ? inventoryType.replaceAll("_", " ")
          : "";

  if (redirectTo) {
    return (
      <Navigate
        to="/settings/accounts-and-billing"
        state={{
          redirectPageParams: {
            activeTab: "accounts-and-billing",
            subTab: buttonSelection,
          },
        }}
      />
    );
  }
  return (
    <Modal
      show={showBuyAddonPlan}
      onHide={hideModal}
      className="inventory-consumption-modal"
      centered
      style={{ zIndex: 99999 }}
    >
      <Modal.Header closeButton closeVariant="black" className="inventory-consumption-modal__header">
        <Modal.Title>{locale("Inventory Consumption")}</Modal.Title>
      </Modal.Header>
      <Modal.Body className="inventory-consumption-modal__body">
        {locale(
          "You have reached the limit for {inventoryType}. You can choose one of the following options",
          {
            inventoryType: formattedInventoryType,
          }
        )}
      </Modal.Body>
      <Modal.Footer className="inventory-consumption-modal__footer">
        <Button
          variant="outline-secondary"
          className="inventory-consumption-modal__dismiss"
          onClick={hideModal}
        >
          {locale("Do Later")}
        </Button>
        <Button
          variant="success"
          className="inventory-consumption-modal__upgrade"
          onClick={() => buyAddonPlan("plan")}
        >
          {locale("Upgrade Plan")}
        </Button>
      </Modal.Footer>
    </Modal>
  );
};
